import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var Random = /*#__PURE__*/function () {
  function Random() {
    _classCallCheck(this, Random);
    this.enable = false;
    this.minimumValue = 0;
  }
  _createClass(Random, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      if (data.minimumValue !== undefined) {
        this.minimumValue = data.minimumValue;
      }
    }
  }]);
  return Random;
}();